import gql from 'graphql-tag';

export default (requestId, provider) => gql`
    mutation DeleteSocialProvider {
      deleteSocialProvider (
        requestId: "${requestId}",
        provider: "${provider}"
      ) {
        id
        requestId
        provider
        name
        email
        photoUrl
        createdAt
      }
    }
  `;
